import { render, staticRenderFns } from "./ItemGol.vue?vue&type=template&id=66b58d0a&scoped=true&"
import script from "./ItemGol.vue?vue&type=script&lang=js&"
export * from "./ItemGol.vue?vue&type=script&lang=js&"
import style0 from "./ItemGol.vue?vue&type=style&index=0&id=66b58d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b58d0a",
  null
  
)

export default component.exports